import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UmsService } from '../ums.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';

@Component({
  selector: 'app-exam-setting-page',
  templateUrl: './exam-setting-page.component.html',
  styleUrls: ['./exam-setting-page.component.scss']
})
export class ExamSettingPageComponent implements OnInit {
  panelOpenState = false;
  Arr = [
    { name: 'Fax', display: '', Require: true, Visible: true },
    { name: 'Address', display: '', Require: false, Visible: true },
    { name: 'Email', display: '', Require: true, Visible: true },

  ];
  isdisabled = false;
  dialogRef: MatDialogRef<any>;
  ExamData: FormArray;
  TransferScrutiny: FormArray;
  LeavingScrutiny: FormArray;
  MigrationScrutiny: FormArray;
  TranscriptScrutiny: FormArray;
  AdmCancelScrutiny: FormArray;
  DivisionBranch: FormArray;
  AggregateExam: FormArray;
  ExamSchedule: FormArray;
  College: FormArray;
  Course: FormArray;
  Grievance: FormArray;
  ExamDataTable: []
  StudentEdit: FormGroup;

  ss: any[];
  constructor(
    private modalPopupService: ModalpopService,
    public umsService: UmsService,
    private fb: FormBuilder,
    public router: Router,
    private dialog: MatDialog,
  ) {
    // this.dataSource2.data = TREE_DATA;  
  }
  // hasChild = (_: number, node: FoodNode) => !!node.Arr && node.Arr.length >= 0;

  arr1: any = [];
  aar: any = [];
  StudentArr: any = [];
  adminArr: any = [];
  ngOnInit(): void {
    let id = '';
    // this.check = false;
    this.StudentEdit = this.fb.group({
      FormName: new FormControl(''),
      FormRequired: new FormControl(''),
      FormVisible: new FormControl(''),
      FormDisplayName: new FormControl(''),
      FormPattern: new FormControl(''),
      FormControlName: new FormControl(''),
      FormType: new FormControl(''),
      FormPage: new FormControl(''),
      IsDefault: new FormControl(''),
      ExamData: new FormArray([]),
      TransferScrutiny: new FormArray([]),
      LeavingScrutiny: new FormArray([]),
      MigrationScrutiny: new FormArray([]),
      TranscriptScrutiny: new FormArray([]),
      AdmCancelScrutiny: new FormArray([]),
      DivisionBranch: new FormArray([]),
      AggregateExam: new FormArray([]),
      ExamSchedule: new FormArray([]),
      Course: new FormArray([]),
      College: new FormArray([]),
      Grievance: new FormArray([]),
    });
  }

  ngAfterViewInit(): void {
    // sessionStorage.clear();
  }

  getExamDataControls() {
    return (this.StudentEdit.get('ExamData') as FormArray).controls;
  }
  getDivisionBranchControls() {
    return (this.StudentEdit.get('DivisionBranch') as FormArray).controls;
  }
  getAggregateExamControls() {
    return (this.StudentEdit.get('AggregateExam') as FormArray).controls;
  }
  getExamScheduleControls() {
    return (this.StudentEdit.get('ExamSchedule') as FormArray).controls;
  }
  getCourseControls() {
    return (this.StudentEdit.get('Course') as FormArray).controls;
  }
  getGrievanceControls() {
    return (this.StudentEdit.get('Grievance') as FormArray).controls;
  }
  getCollegeControls() {
    return (this.StudentEdit.get('College') as FormArray).controls;
  }
  getTransferControls() {
    return (this.StudentEdit.get('TransferScrutiny') as FormArray).controls;
  }
  getLeavingControls(){
    return(this.StudentEdit.get('LeavingScrutiny') as FormArray).controls;
  }
  getMigrationControls(){
    return(this.StudentEdit.get('MigrationScrutiny') as FormArray).controls;
  }
  getTranscriptControls(){
    return(this.StudentEdit.get('TranscriptScrutiny') as FormArray).controls;
  }
  getAdmCancelControls(){
    return(this.StudentEdit.get('AdmCancelScrutiny') as FormArray).controls;
  }

  getData(id) {
    const payload = {};
    payload['FormPage'] = id;
    //dynamic not showing for insti 6
    // payload['Inst'] = sessionStorage.getItem('Inst');
    this.umsService.getStdSetting(payload).subscribe(res => {
      this.ExamDataTable = res.data
      this.ExamData = this.StudentEdit.get('ExamData') as FormArray;
      this.ExamData.clear();
      this.TransferScrutiny = this.StudentEdit.get('TransferScrutiny') as FormArray;
      this.TransferScrutiny.clear();
      this.LeavingScrutiny = this.StudentEdit.get('LeavingScrutiny') as FormArray;
      this.LeavingScrutiny.clear();
      this.MigrationScrutiny = this.StudentEdit.get('MigrationScrutiny') as FormArray;
      this.MigrationScrutiny.clear();
      this.TranscriptScrutiny = this.StudentEdit.get('TranscriptScrutiny') as FormArray;
      this.TranscriptScrutiny.clear();
      this.AdmCancelScrutiny = this.StudentEdit.get('AdmCancelScrutiny') as FormArray;
      this.AdmCancelScrutiny.clear();
      this.ExamDataTable.map((element, i) => {
        if (element['FormPage'] == 'ExamData') {
          this.ExamData = this.StudentEdit.get('ExamData') as FormArray;
          if (element['FormVisible'] == false) {
            this.ExamData.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl({ value: element['FormRequired'], disabled: true }),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('Exam'),
            }));
          } else {
            this.ExamData.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl(element['FormRequired']),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('Exam'),
            }));
          }

        }
        else if (element['FormPage'] == 'DivisionBranch') {
          this.DivisionBranch = this.StudentEdit.get('DivisionBranch') as FormArray;
          if (element['FormVisible'] == false) {
            this.DivisionBranch.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl({ value: element['FormRequired'], disabled: true }),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('Exam'),
            }));
          } else {
            this.DivisionBranch.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl(element['FormRequired']),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('Exam'),
            }));
          }

        }
        else if (element['FormPage'] == 'TransferScrutiny') {
          this.TransferScrutiny = this.StudentEdit.get('TransferScrutiny') as FormArray;
          if (element['FormVisible'] == false) {
            this.TransferScrutiny.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl({ value: element['FormRequired'], disabled: true }),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('TransferScrutiny'),
            }));
          } else {
            this.TransferScrutiny.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl(element['FormRequired']),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('TransferScrutiny'),
            }));
          }

        }
        else if (element['FormPage'] == 'LeavingScrutiny') {
          this.LeavingScrutiny = this.StudentEdit.get('LeavingScrutiny') as FormArray;
          if (element['FormVisible'] == false) {
            this.LeavingScrutiny.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl({ value: element['FormRequired'], disabled: true }),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('LeavingScrutiny'),
            }));
          } else {
            this.LeavingScrutiny.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl(element['FormRequired']),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('LeavingScrutiny'),
            }));
          }

        }
        else if (element['FormPage'] == 'MigrationScrutiny') {
          this.MigrationScrutiny = this.StudentEdit.get('MigrationScrutiny') as FormArray;
          if (element['FormVisible'] == false) {
            this.MigrationScrutiny.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl({ value: element['FormRequired'], disabled: true }),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('MigrationScrutiny'),
            }));
          } else {
            this.MigrationScrutiny.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl(element['FormRequired']),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('MigrationScrutiny'),
            }));
          }

        }
        else if (element['FormPage'] == 'TranscriptScrutiny') {
          this.TranscriptScrutiny = this.StudentEdit.get('TranscriptScrutiny') as FormArray;
          if (element['FormVisible'] == false) {
            this.TranscriptScrutiny.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl({ value: element['FormRequired'], disabled: true }),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('TranscriptScrutiny'),
            }));
          } else {
            this.TranscriptScrutiny.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl(element['FormRequired']),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('TranscriptScrutiny'),
            }));
          }

        }
        else if (element['FormPage'] == 'AdmCancelScrutiny') {
          this.AdmCancelScrutiny = this.StudentEdit.get('AdmCancelScrutiny') as FormArray;
          if (element['FormVisible'] == false) {
            this.AdmCancelScrutiny.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl({ value: element['FormRequired'], disabled: true }),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('AdmCancelScrutiny'),
            }));
          } else {
            this.AdmCancelScrutiny.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl(element['FormRequired']),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('AdmCancelScrutiny'),
            }));
          }

        }
        else if (element['FormPage'] == 'AggregateExam') {
          this.AggregateExam = this.StudentEdit.get('AggregateExam') as FormArray;
          if (element['FormVisible'] == false) {
            this.AggregateExam.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl({ value: element['FormRequired'], disabled: true }),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('Exam'),
            }));
          } else {
            this.AggregateExam.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl(element['FormRequired']),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('Exam'),
            }));
          }

        }
        else if (element['FormPage'] == 'ExamSchedule') {
          this.ExamSchedule = this.StudentEdit.get('ExamSchedule') as FormArray;
          if (element['FormVisible'] == false) {
            this.ExamSchedule.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl({ value: element['FormRequired'], disabled: true }),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('Exam'),
            }));
          } else {
            this.ExamSchedule.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl(element['FormRequired']),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('Exam'),
            }));
          }

        } else if (element['FormPage'] == 'Course') {
          this.Course = this.StudentEdit.get('Course') as FormArray;
          if (element['FormVisible'] == false) {
            this.Course.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl({ value: element['FormRequired'], disabled: true }),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('Course'),
            }));
          } else {
            this.Course.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl(element['FormRequired']),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('Course'),
            }));
          }

        } else if (element['FormPage'] == 'College') {
          this.College = this.StudentEdit.get('College') as FormArray;
          if (element['FormVisible'] == false) {
            this.College.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl({ value: element['FormRequired'], disabled: true }),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('College'),
            }));
          } else {
            this.College.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl(element['FormRequired']),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('College'),
            }));
          }

        } else if (element['FormPage'] == 'Grievance') {
          this.Grievance = this.StudentEdit.get('Grievance') as FormArray;
          if (element['FormVisible'] == false) {
            this.Grievance.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl({ value: element['FormRequired'], disabled: true }),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('Grievance'),
            }));
          } else {
            this.Grievance.push(this.fb.group({
              FormName: new FormControl(element['FormName']),
              FormRequired: new FormControl(element['FormRequired']),
              FormVisible: new FormControl(element['FormVisible']),
              FormDisplayName: new FormControl(element['FormDisplayName']),
              FormPattern: new FormControl(element['FormPattern']),
              FormControlName: new FormControl(element['FormControlName']),
              FormType: new FormControl(element['FormType']),
              FormPage: new FormControl(element['FormPage']),
              IsDefault: new FormControl(element['IsDefault']),
              ID: new FormControl(element['ID']),
              Module: new FormControl('Grievance'),
            }));
          }

        }

      });
    });

  }


  redirect(to: string): void {
    this.router.navigate([to]);
  }

  next() {
    this.redirect('student-form');
  }
  Regnext() {
    this.redirect('student-registration-tab');
  }

  updateDetails(e) {
    this.umsService.updateStdSetting(e.getRawValue()).subscribe(res => {
      const data = {};
      data['message'] = res.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-check';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  visableChange(i, value, page) {
    // if(i == 1)
    if (value.FormVisible == false) {
      let taskListArrays = this.StudentEdit.get(page) as FormArray;
      if (taskListArrays.controls[i].value.FormVisible == false) {
        taskListArrays.controls[i].patchValue({ "FormRequired": false });
        taskListArrays.controls[i].get('FormRequired').disable();
        taskListArrays.controls[i].patchValue({ "FormRequired": false });
      }
    } else if (value.FormVisible == true) {
      let taskListArrays = this.StudentEdit.get(page) as FormArray;
      if (taskListArrays.controls[i].value.FormVisible == true) {
        taskListArrays.controls[i].get('FormRequired').enable();
      }
    }
  }

}
